import React, { FC } from "react";
import styles from "./IntroScreen.module.css";

const IntroScreen: FC<{ widgetId: string }> = ({ widgetId }) => {
  return (
    <div className={styles.intro_wrap}>
      <div className={styles.intro_area}>
        <iframe title="Intro" src={`${window.__PATH__?.appUrls.pageDesigner}preview-template/${widgetId}?hideTopBand=true`} />
      </div>
    </div>
  );
};

export default IntroScreen;
